export const API_ENDPOINTS = {
  GET_TOURS: `${process.env.REACT_APP_CALENDAR_BASE_URL}${process.env.REACT_APP_TOURS_ENDPOINT}`,
  // GET_CATEGORIES: `${process.env.REACT_APP_ECOMMERCE_BASE_URL}${process.env.REACT_APP_CATEGORIES_ENDPOINT}`,
  GET_CATEGORIES: (has_product_ids) =>
    `${process.env.REACT_APP_ECOMMERCE_BASE_URL}${process.env.REACT_APP_CATEGORIES_ENDPOINT}?has_product_ids=${has_product_ids}&list_category_titles_and_ids`,
  TOURS_DETAILS: ({ products_id }) =>
    `${process.env.REACT_APP_ECOMMERCE_BASE_URL}${process.env.REACT_APP_TOURS_DETAILS_ENDPOINT}?products_id=${products_id}`,
  ADD_ATTENDANCE: `${process.env.REACT_APP_CALENDAR_BASE_URL}${process.env.REACT_APP_ADD_ATTENDANCE_ENDPOINT}`,
  SEND_OTP: `${process.env.REACT_APP_ACCOUNTING_BASE_URL}${process.env.REACT_APP_SEND_OTP_ENDPOINT}`,
  VERIFY_OTP: `${process.env.REACT_APP_ACCOUNTING_BASE_URL}${process.env.REACT_APP_VERIFY_OTP_ENDPOINT}`,
  CUSTOMER_BOOKINGS: ({ customerId }) =>
    `${process.env.REACT_APP_CALENDAR_BASE_URL}${process.env.REACT_APP_CUSTOMER_BOOKINGS_ENDPOINT}/${customerId}`,
  CHANGE_TOUR_STATUS: ({ customerId, tourId }) =>
    `${process.env.REACT_APP_CALENDAR_BASE_URL}${process.env.REACT_APP_CHANGE_TOUR_STATUS_ENDPOINT}/${localStorage.getItem("customerId")}/${tourId}`,
  UPDATE_ATTENDANCE: () =>
    `${process.env.REACT_APP_CALENDAR_BASE_URL}${process.env.REACT_APP_UPDATE_MULTIPLE_ATTENDANCE_ENDPOINT}`,
  GET_CATEGORIES_AFTER_BOOKING: (category_ids) =>
    `${process.env.REACT_APP_ECOMMERCE_BASE_URL}${process.env.REACT_APP_CATEGORIES_ENDPOINT}?list_category_titles_and_ids=&category_ids=${category_ids}`,
  TOURS_DETAILS_AFTER_BOOKING: ({ products_id }) =>
    `${process.env.REACT_APP_ECOMMERCE_BASE_URL}${process.env.REACT_APP_TOURS_DETAILS_ENDPOINT}?products_id=${products_id}/get_category_ids`,
  SEND_CONFIRM_TO_EMAIL: `${process.env.REACT_APP_ACCOUNTING_BASE_URL}${process.env.REACT_APP_SEND_CONFIRM_TO_EMAIL_ENDPOINT}`,
  VENUES: ({ venues_ids }) =>
    `${process.env.REACT_APP_ECOMMERCE_BASE_URL}${process.env.REACT_APP_VENUES_ENDPOINT}?venues_ids=${venues_ids}`,
};

export const API_CREDENTIALS = {
  API_KEY: process.env.REACT_APP_API_KEY,
  API_CONNECTION: process.env.REACT_APP_API_CONNECTION,
  SECURE_BUSINESS_KEY: process.env.REACT_APP_BUSINESS_KEY,
};
